module.exports = __webpack_public_path__ + "media/v2/components/HomePage/shared/Prizes/memorabilia-5feb2e5043477ac75a76b4d4fcde2641.svg";